export default __webpack_public_path__ + "static/media/sameCity.6ebb51e2.png";